import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";

import { Button, Input, Row } from "antd";
import ButtonGroup from "antd/es/button/button-group";

import Swal from "sweetalert2";

import channelUserApi from "../../../apis/ChannelUser.api";
import { setChannelUser } from "../../../redux/store/auth/authDuck";

const LoginComponent = () => {
	const dispatch = useDispatch();
	const history = useHistory();
	const reduxChannel = useSelector((state) => state.channel.reduxChannel);
	const setCUser = (value) => dispatch(setChannelUser(value));

	// const [mediaResult, setMediaResult] = useState(null);

	useEffect(() => {
		// if (typeof window !== 'undefined') {
		//     const matchQueryList = window.matchMedia('all and (max-width: 768px)');
		//     setMediaResult(matchQueryList.matches);
		//
		//     function handleChange(e) {
		//         setMediaResult(e.matches);
		//     }
		//
		//     matchQueryList.addEventListener("change", handleChange);
		// }
		naverLoginInit();
		if (!window.Kakao?.isInitialized()) {
			// 두번째 step 에서 가져온 javascript key 를 이용하여 initialize
			window.Kakao?.init(process.env.REACT_APP_KAKAO_KEY);
		}
	}, []);

	/**
	 * 일반 로그인 데이터
	 */
	const [userLogin, setUserLogin] = useState({
		phone: "",
		password: "",
	});

	/**
	 * 일반 로그인 정보 받기
	 * @param e
	 */
	const handleUserLogin = (e) => {
		let { name, value } = e.target;
		let phone = value?.replaceAll(/[^0-9]/g, "");
		if (name === "phone") {
			if (value?.length <= 11) {
				setUserLogin({
					...userLogin,
					[name]: phone,
				});
			}
		} else {
			setUserLogin({
				...userLogin,
				[name]: value,
			});
		}
	};

	/**
	 * back-page session 저장
	 */
	const onSaveBackPageSession = () => {
		let { pathname, search } = window.location;
		sessionStorage.setItem("influencer_id", reduxChannel?.influencer_id);
		sessionStorage.setItem("influencer_user_id", reduxChannel?.user_id);
		if (
			!pathname.includes("login") &&
			!pathname.includes("find") &&
			!pathname.includes("signup")
		) {
			sessionStorage.setItem("backPage", pathname + search);
		}
	};

	/**
	 * 일반 로그인 버튼 클릭
	 */
	const submitUserLogin = async () => {
		onSaveBackPageSession();
		const backPage = sessionStorage.getItem("backPage");
		const param = {
			...userLogin,
			influencer_id: reduxChannel?.user_id,
		};
		const res = await channelUserApi.login(param);
		if (res?.code === 200) {
			const result = res.result;
			localStorage.setItem("accessToken", result.tokenDto.accessToken);
			localStorage.setItem("refreshToken", result.tokenDto.refreshToken);
			// console.log(result);
			setCUser(result.user);
			// dispatch(setUser(result.user));
			// setCUser(result.user);
			// console.log(result.users);
			// console.log(`/share/${reduxChannel?.influencer_id}`);

			const userAgent = window.navigator?.userAgent;
			const userAgentData = window.navigator?.userAgentData;
			// const rsp = await axios.get('https://geolocation-db.com/json/');
			// if (rsp.status === 200) {
			const param = {
				user_id: result?.user?.id ?? 1,
				device_id: userAgent?.replace("Mozilla/5.0", "")?.trim(),
				device_agent: userAgentData?.platform,
				// device_ip: rsp.data.IPv4,
			};
			const rsq = await channelUserApi.postChannelUserIp(param);
			if (rsq.code) {
				if (backPage) {
					history.replace(backPage);
					sessionStorage.removeItem("backPage");
				} else {
					history.push(`/together/channel?id=${reduxChannel?.influencer_id}`);
				}
			}
			// }
		} else {
			Swal.fire({
				customClass: "alert-custom",
				text: "휴대폰 번호 또는 비밀번호가 일치하지 않습니다.",
				confirmButtonText: "확인",
			});
		}
	};

	/**
	 * 카카오 로그인
	 * @returns {Promise<void>}
	 */
	const kakaoLogin = async () => {
		onSaveBackPageSession();
		if (window.Kakao) {
			// if (user.provider === "guest") {
			//     let param = {
			//         id: user.id,
			//         user_id: user.user_id,
			//     };
			//     await api.leave(param);
			// }
			window.Kakao.Auth.authorize({
				redirectUri: `${process.env.REACT_APP_HOST}/together/channel/user/sns/kakao`,
				scope:
					"gender birthyear birthday profile_nickname phone_number talk_message friends",
			});
		}
	};

	/**
	 * 네이버 로그인 설정
	 */
	const naverLoginInit = () => {
		const naverLogin = new window.naver.LoginWithNaverId({
			clientId: process.env.REACT_APP_NAVER_KEY,
			callbackUrl: `${process.env.REACT_APP_HOST}/together/channel/user/sns/naver`,
			callbackHandle: true,
			isPopup: false, // 로그인 팝업여부
			loginButton: {
				color: "green", // 색상(white, green)
				type: 3, // 버튼타입(1,2,3)
				height: 60, // 배너 및 버튼 높이
			},
		});

		naverLogin.init();
		naverLogin.logout(); // 네이버 로그인이 계속 유지되는 경우가 있다. 초기화시 로그아웃
	};

	return (
		<div className={`home-recommend-vertical login-vertical`}>
			<div className={`login-div`}>
				<img
					src={`/assets/images/login/recent-login.png`}
					alt={`최근 로그인`}
					className={`recently-login-icon`}
				/>
				<p className={`login-title`}>휴대폰 번호 로그인</p>
				<Input
					type={"text"}
					placeholder={`휴대폰 번호`}
					pattern="\d*"
					name={"phone"}
					value={userLogin.phone}
					onChange={handleUserLogin}
				/>
				<Input
					type={"password"}
					placeholder={`비밀번호`}
					name={"password"}
					value={userLogin.password}
					onChange={handleUserLogin}
					onPressEnter={submitUserLogin}
				/>
				{/*<ButtonGroup*/}
				{/*    className={`save-info-button-group`}*/}
				{/*    align={"middle"}*/}
				{/*>*/}
				{/*    <Button>*/}
				{/*        <img src={`/assets/images/login/black-check.png`}*/}
				{/*             alt={`naver-icon`}*/}
				{/*        />*/}
				{/*        아이디 저장*/}
				{/*    </Button>*/}
				{/*    <Button>*/}
				{/*        <img src={`/assets/images/login/white-check.png`}*/}
				{/*             alt={`naver-icon`}*/}
				{/*        />*/}
				{/*        비밀번호 저장*/}
				{/*    </Button>*/}
				{/*</ButtonGroup>*/}
				<Button
					className={`black-full-button`}
					style={{ fontSize: "1em" }}
					onClick={submitUserLogin}
				>
					로그인
				</Button>
				<ButtonGroup className={`button-group-full`}>
					{/*<Button>아이디 찾기</Button>*/}
					<Button
						onClick={() => {
							onSaveBackPageSession();
							history.push(
								`/together/channel/find/user?id=${reduxChannel?.influencer_id}`
							);
						}}
					>
						비밀번호 찾기
					</Button>
					<Button
						onClick={() => {
							onSaveBackPageSession();
							history.push(
								`/together/channel/signup?id=${reduxChannel?.influencer_id}`
							);
						}}
					>
						회원가입
					</Button>
				</ButtonGroup>
				<Row className={`login-signup-div`}>
					<p>휴대폰 번호로 회원가입하기</p>
					<Link
						to={`/together/channel/signup?id=${reduxChannel?.influencer_id}`}
						size={`small`}
						onClick={() => {
							onSaveBackPageSession();
						}}
					>
						회원가입
					</Link>
				</Row>
			</div>
			<div className={`login-div`}>
				<p className={`login-title`}>SNS 로그인 / 회원가입</p>
				<ButtonGroup
					className={`sns-login-button-group`}
					style={{
						position: "relative",
					}}
				>
					<Button
						className={`kakao-button`}
						onClick={kakaoLogin}
						style={{ fontSize: "1em" }}
					>
						<img
							src={`/assets/images/login/recent-login.png`}
							alt={`최근 로그인`}
							className={`recently-login-icon sns`}
						/>
						<img src={`/assets/images/login/kakao.png`} alt={`kakao-icon`} />
						카카오 간편 로그인 / 회원가입
					</Button>
					<Button
						className={`naver-button`}
						onClick={() => {
							onSaveBackPageSession();
							let naverLoginButton =
								document.querySelector("#naverIdLogin").firstChild;
							naverLoginButton.click();
						}}
						style={{ fontSize: "1em" }}
					>
						<img
							src={`/assets/images/login/recent-login.png`}
							alt={`최근 로그인`}
							className={`recently-login-icon sns`}
						/>
						<img src={`/assets/images/login/naver.png`} alt={`naver-icon`} />
						네이버 간편 로그인 / 회원가입
					</Button>
					<div id="naverIdLogin" style={{ display: "none" }} />
				</ButtonGroup>
			</div>
		</div>
	);
};
export default LoginComponent;
